import { isEmpty } from 'lodash-es';
import { createContext, useState, useContext, PropsWithChildren, useEffect } from 'react';
import { ICandidateStageStatusPipelineSetting } from 'wisestep-api';

import { getStageStatusSettings } from '../../../utils/CandidateStageStatusHelper';
import DefaultStageStatusPipeline from '../../../utils/DefaultStageStatusPipeline';

export const StageStatusContext = createContext<ICandidateStageStatusPipelineSetting | null>(null);

export default function StageStatusContextProvider(
  props: PropsWithChildren<ICandidateStageStatusPipelineSetting | null>
) {
  const [stageState, setStageState] = useState<ICandidateStageStatusPipelineSetting | null>(null);

  useEffect(() => {
    (async function () {
      if (isEmpty(stageState)) {
        try {
          const req = await getStageStatusSettings();
          if (req?.data?.id) {
            setStageState(req.data);
          } else {
            setStageState(DefaultStageStatusPipeline);
          }
        } catch (e) {
          setStageState(DefaultStageStatusPipeline);
        }
      }
    })();
  }, [stageState]);

  return (
    <StageStatusContext.Provider value={{ ...stageState }}>
      {props.children}
    </StageStatusContext.Provider>
  );
}

export function useStageStatusContext() {
  const context = useContext(StageStatusContext);
  if (!context) {
    throw new Error('useAppState must be used within the StageStatusContextProvider');
  }
  return context;
}
